export var SapObjectType;
(function (SapObjectType) {
    SapObjectType["SAP_OBJECT_TYPE_TABLE"] = "TABLE";
    SapObjectType["SAP_OBJECT_TYPE_CDS_VIEW"] = "CDS_VIEW";
    SapObjectType["SAP_OBJECT_TYPE_EXTRACTOR"] = "EXTRACTOR";
})(SapObjectType || (SapObjectType = {}));
